import { InputCheckbox } from '@creditornot/cb-checkbox';
import { cbSemanticCssVars, colors, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import styled, { css } from 'styled-components';

import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { DiscountedItem } from 'modules/campaigns/hooks/useDiscountedItems';

export type DiscountedItemRowProps = {
  item: DiscountedItem;
  selected?: boolean;
  onSelect?: () => void;
};

const DiscountItem = styled.label<{ $selectable: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-block: 16px;
  padding-inline: 24px 16px;
  width: 100%;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};

  ${({ $selectable }) =>
    $selectable &&
    css`
      padding-inline-start: 48px;

      &:hover {
        background-color: ${colors.wolt4};
      }
    `}
`;

const ImageContainer = styled.span`
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  border: 1px solid ${cbSemanticCssVars.borderPrimary};
  background: ${cbSemanticCssVars.surfaceMain};
  overflow: hidden;
`;

const ItemImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ItemLabel = styled.span`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-inline-end: 32px;
`;

const ItemName = styled.span`
  ${typographyCss.Body3()}
  font-weight: 500;
`;

const ItemDescription = styled.span`
  ${typographyCss.Small()}
  color: ${cbSemanticCssVars.textSecondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ItemPrice = styled.span`
  ${typographyCss.Body3()}
  font-weight: 600;
  margin-inline-start: auto;
`;

export const DiscountedItemRow = ({ item, selected, onSelect }: DiscountedItemRowProps) => {
  const { id, baseprice, image, name, description } = item;

  return (
    <DiscountItem $selectable={!!onSelect}>
      {!!onSelect && <InputCheckbox value={id} checked={selected} onChange={onSelect} />}
      <ImageContainer>{!!image && <ItemImage src={image} alt="" aria-hidden="true" />}</ImageContainer>
      <ItemLabel>
        <ItemName>{name}</ItemName>
        <ItemDescription>{description}</ItemDescription>
      </ItemLabel>
      <ItemPrice>
        <MonetaryAmount amount={parseFloat(baseprice.amount)} currency={baseprice.currency} />
      </ItemPrice>
    </DiscountItem>
  );
};
